import { render, staticRenderFns } from "./chat-avatar.vue?vue&type=template&id=7fc30ada"
import script from "./chat-avatar.vue?vue&type=script&lang=js"
export * from "./chat-avatar.vue?vue&type=script&lang=js"
import style0 from "./chat-avatar.vue?vue&type=style&index=0&id=7fc30ada&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports